import { PUBMED_DOWNLOAD } from "@/graphql/pubmed.graphql";
import { useLazyQuery } from "@apollo/react-hooks";

const usePaperDownload = (doi: string) => {
  const [download, { called, loading, data }] = useLazyQuery(PUBMED_DOWNLOAD);
  const loadDownload = () => download({ variables: { doi } });

  return {
    loadDownload,
    loading,
    data,
    called,
  };
};
export default usePaperDownload;
